/**
 * @description `AdvocacyPanel` CMS component key: lazily loads the Advocacy page module so
 *              its images and styles stay out of the main bundle.
 * @filename index.tsx
 */

import * as React from "react";
import Loadable from "react-loadable";
import OptionsWithoutRender = LoadableExport.OptionsWithoutRender;
import { Loader } from "../../page/loader";

const loadableOptions: OptionsWithoutRender<{}> = {
  loader: () => import("../../../modules/advocacy").then((module) => module.AdvocacyPanel) as Promise<any>,
  loading: () => <Loader isActive={true} />,
};

export const AdvocacyPanel = Loadable(loadableOptions);
